import t from 'react-translate';
import { useSelector } from 'react-redux';
import { getNpsCsatConfiguration } from 'redux/selectors/analytics';
import NvIcon from 'shared/components/nv-icon';

const ConfigureLink = ({ onClick }: { onClick?: () => void }) => {
  const npsCsatConfig = useSelector(getNpsCsatConfiguration);
  const isConfigured = Boolean(npsCsatConfig?.configured);
  return (<div className='d-flex justify-content-center my-2'>
      <button
        type='button'
        className='d-flex align-items-center border-0 bg-transparent color-primary mr-4'
        onClick={onClick}
      >
        <NvIcon size='smallest' icon='edit' className='pr-2 d-inline-block ' />
        {isConfigured ? t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.EDIT_CONFIGURATION() : t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CONFIGURE()}
      </button>
    </div>);
};

export default ConfigureLink;
